// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Listar,
} from './';

export default {
  path: 'pessoas',
  name: 'Pessoas',
  childRoutes: [
    { path: 'listar', name: 'Listar', component: Listar, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/pessoas/route.js